import premium_logo from 'src/assets/premium_logo.png';

import React, { useContext, useEffect, useState } from 'react'
import {
  CPPHeader,
  CPPHeaderProgress,
  CPPHeaderProgressFilled,
  CPPInternalBackButton,
  CPPInternalContainer,
  CPPInternalTitle,
  CPPNumberOfDaysContainer,
  CPPNumberOfDaysItem,
  CPPProceedButton,
  CPPSessionLengthContainer,
  CPPSessionLengthContainerTitle,
  CPPTimeButton,
  CreatePlanPageBackground,
} from './createPlanPageStyles'
import { GenericHeaderBackButton } from './MyPlanComponents'
import Slider from '@mui/material/Slider'
import ArrowBackIcon from '@mui/icons-material/ArrowBack'
import { CPPCustomLottie, CPPTimeSelector } from './CreatePlanPageComponents'
import successGreenTickRotatingLottie from 'src/consumer/lotties/successGreenTickRotatingLottie.json'
import { SetupContext } from 'src/consumer/context/SetupContext'
import { GenericDisplayFlex, GenericDisplayFlexColumn } from 'src/mentor/layout/Styles'
import { getHoursAndMinutesFromMinutes } from 'src/mentor/helpers/utilityFunctions'
import dayjs from 'dayjs'
import { useNavigate, useOutletContext } from 'react-router-dom'
import { Spinner } from 'react-bootstrap'
import { ProfileContext } from 'src/consumer/context/ProfileContext'
import { getDataWithoutParams, prepareDataForPlan } from 'src/consumer/services/featureServices'
import { putData } from 'src/consumer/services/profileService'
import { toast } from 'react-toastify'
import { makeStyles } from '@mui/material'

export default function CreatePlanPage() {
  const { setupData } = useContext(SetupContext)
  const { profileData } = useContext(ProfileContext)
  const pages = ['number_of_days', 'set_session_length', 'set_time', 'plan_created'] // analysing
  const [numberOfDaysOptions, setNumberOfDaysOptions] = useState()
  const [activePage, setActivePage] = useState(pages[0])
  const navigate = useNavigate()
  const [selectedDaysForPlan, setSelectedDaysForPlan] = useState()
  const [planMinutes, setPlanMinutes] = useState(30)
  const [chosenTime, setChosenTime] = useState(
    dayjs().set({ hour: 7, minute: 0, second: 0, millisecond: 0 }).format('YYYY-MM-DD HH:mm:ss'),
  )
  const [recommendedDaysForPlan, setRecommendedDaysForPlan] = useState()
  const [createPlanLoading, setCreatePlanLoading] = useState(true)
  const { openPrewallFunction } = useOutletContext()

  useEffect(() => {
    if (setupData?.metaPlans) {
      let number_of_days_options = []
      setupData?.metaPlans?.forEach((item) => {
        number_of_days_options.push(item.days)
        if (item?.recommended) {
          setRecommendedDaysForPlan(item.days)
        }
      })
      setNumberOfDaysOptions(number_of_days_options)
      setSelectedDaysForPlan(number_of_days_options[0])
    } else {
      setNumberOfDaysOptions([4, 11, 21, 40])
      setSelectedDaysForPlan(4)
    }
  }, [])

  // ui related:
  const marks = [
    {
      value: 2,
      label: '2 minutes',
    },
    {
      value: 120,
      label: '2 hours',
    },
  ]

  const useStyles = makeStyles({
    markLabel: {
      color: '#fff', // Your desired mark color
    },
  })
  const classes = useStyles()

  const submitPlan = async () => {
    setCreatePlanLoading(true)
    const data = prepareDataForPlan(selectedDaysForPlan, planMinutes, chosenTime, profileData)
    const response = await putData('/api/secure/user/personalize', data, '')
    const responseTwo = await getDataWithoutParams(
      `/api/secure/user/plan/change?event=new&noOfDays=${selectedDaysForPlan}`,
    )
    if (response.status === 200 && responseTwo.status === 200) {
      setCreatePlanLoading(false)
    } else {
      toast.error('Error creating plan')
    }
  }

  return (
    <CreatePlanPageBackground>
      <CPPHeader>
        <GenericHeaderBackButton />
      </CPPHeader>
      <CPPInternalContainer>
        <CPPHeaderProgress>
          <CPPHeaderProgressFilled
            progress={((pages.findIndex((item) => item === activePage) + 1) / pages.length) * 100}
          />
        </CPPHeaderProgress>
        {pages.findIndex((item) => item === activePage) !== 0 && (
          <CPPInternalBackButton
            onClick={() => {
              setActivePage(pages[pages.findIndex((item) => item === activePage) - 1])
            }}
          >
            <ArrowBackIcon sx={{ color: 'white', fontSize: '10', cursor: 'pointer' }} />
          </CPPInternalBackButton>
        )}
        {activePage === 'number_of_days' && (
          <div>
            <CPPInternalTitle main>Build your plan</CPPInternalTitle>
            <CPPInternalTitle>Let&apos;s build a starting plan for you</CPPInternalTitle>
            <CPPNumberOfDaysContainer>
              {numberOfDaysOptions?.map((days, index) => {
                return (
                  <CPPNumberOfDaysItem
                    key={index}
                    selected={selectedDaysForPlan === days}
                    onClick={() => {
                      if (
                        profileData?.subscriptionTypeId === 'subscription_free' &&
                        (setupData?.metaPlans?.find((item) => item?.days === days)).paid
                      ) {
                        openPrewallFunction('content_play')
                      } else {
                        setSelectedDaysForPlan(days)
                      }
                    }}
                  >
                    <div>{days} day plan</div>
                    <div>{recommendedDaysForPlan === days && '(Recommended)'}</div>
                    {profileData?.subscriptionTypeId === 'subscription_free' &&
                      (setupData?.metaPlans?.find((item) => item?.days === days)).paid && (
                        <img
                          src={premium_logo}
                          style={{ width: '20px', marginTop: '10px' }}
                          alt="premiumlogo"
                        />
                      )}
                  </CPPNumberOfDaysItem>
                )
              })}
            </CPPNumberOfDaysContainer>
            {pages.findIndex((item) => item === activePage) !== pages.length - 1 && (
              <CPPProceedButton
                onClick={() =>
                  setActivePage(pages[pages.findIndex((item) => item === activePage) + 1])
                }
              >
                Proceed
              </CPPProceedButton>
            )}
          </div>
        )}
        {activePage === 'set_session_length' && (
          <div style={{ width: '100%' }}>
            <CPPInternalTitle main>Set session length</CPPInternalTitle>
            <CPPSessionLengthContainer>
              <CPPSessionLengthContainerTitle>
                Session length you are comfortable with?
              </CPPSessionLengthContainerTitle>
              <Slider
                defaultValue={planMinutes}
                min={2}
                max={120}
                aria-label="Duration in minutes"
                style={{ color: '#20fff8' }}
                marks={marks}
                classes={{ markLabel: classes.markLabel }}
                onChange={(e, nv) => setPlanMinutes(nv)}
              />
              <CPPSessionLengthContainerTitle
                style={{ color: '#FFF', margin: '20px 0 0 0', textAlign: 'center' }}
              >
                Each day your session would be
              </CPPSessionLengthContainerTitle>
              <CPPSessionLengthContainerTitle
                style={{ color: '#FFF', margin: '0', textAlign: 'center' }}
              >
                roughly {getHoursAndMinutesFromMinutes(planMinutes)}
              </CPPSessionLengthContainerTitle>
            </CPPSessionLengthContainer>
            {pages.findIndex((item) => item === activePage) !== pages.length - 1 && (
              <CPPProceedButton
                onClick={() =>
                  setActivePage(pages[pages.findIndex((item) => item === activePage) + 1])
                }
              >
                Next
              </CPPProceedButton>
            )}
          </div>
        )}
        {activePage === 'set_time' && (
          <div style={{ width: '100%' }}>
            <CPPInternalTitle main>Set a convenient time for plan activities</CPPInternalTitle>
            <CPPSessionLengthContainer>
              <CPPSessionLengthContainerTitle>
                Chooose your convenient time
              </CPPSessionLengthContainerTitle>
              <GenericDisplayFlex style={{ gap: '5px' }}>
                <CPPTimeButton
                  left
                  selected={
                    chosenTime ===
                    dayjs()
                      .set({ hour: 7, minute: 0, second: 0, millisecond: 0 })
                      .format('YYYY-MM-DD HH:mm:ss')
                  }
                  onClick={() =>
                    setChosenTime(
                      dayjs()
                        .set({ hour: 7, minute: 0, second: 0, millisecond: 0 })
                        .format('YYYY-MM-DD HH:mm:ss'),
                    )
                  }
                >
                  First thing in the morning
                </CPPTimeButton>
                <CPPTimeButton
                  selected={
                    chosenTime ===
                    dayjs()
                      .set({ hour: 19, minute: 0, second: 0, millisecond: 0 })
                      .format('YYYY-MM-DD HH:mm:ss')
                  }
                  onClick={() =>
                    setChosenTime(
                      dayjs()
                        .set({ hour: 19, minute: 0, second: 0, millisecond: 0 })
                        .format('YYYY-MM-DD HH:mm:ss'),
                    )
                  }
                >
                  Just before bed
                </CPPTimeButton>
              </GenericDisplayFlex>
              <CPPTimeSelector
                key={chosenTime}
                value={chosenTime}
                setValueFunction={(newValue) => setChosenTime(newValue)}
              />
              <CPPSessionLengthContainerTitle
                style={{ color: '#FFF', margin: '20px 0', textAlign: 'center' }}
              >
                Everyday we will remind you 10 mins before your meditation.
              </CPPSessionLengthContainerTitle>
            </CPPSessionLengthContainer>
            {pages.findIndex((item) => item === activePage) !== pages.length - 1 && (
              <CPPProceedButton
                onClick={() => {
                  submitPlan()
                  setActivePage(pages[pages.findIndex((item) => item === activePage) + 1])
                }}
              >
                Proceed
              </CPPProceedButton>
            )}
          </div>
        )}
        {activePage === 'plan_created' &&
          (createPlanLoading ? (
            <div
              style={{
                display: 'flex',
                marginTop: '100px',
                color: '#FFF',
                fontSize: '16px',
                gap: '10px',
              }}
            >
              <span>Creating your plan</span>
              <Spinner animation="border" variant="light" size="sm" />
            </div>
          ) : (
            <GenericDisplayFlexColumn>
              <CPPInternalTitle main style={{ marginTop: '100px' }}>
                Your plan is created
              </CPPInternalTitle>
              <CPPCustomLottie
                animationData={successGreenTickRotatingLottie}
                loop={false}
                autoPlay={true}
              />
              <CPPProceedButton
                onClick={() => {
                  navigate('/')
                }}
              >
                Continue
              </CPPProceedButton>
            </GenericDisplayFlexColumn>
          ))}
      </CPPInternalContainer>
    </CreatePlanPageBackground>
  )
}
